import React from "react";
import { useGlobal, withGlobal } from "reactn";

import { PageHeader } from "@jsluna/site-layout";
import { SainsburysSmartShop, NectarWordmarkWhite } from "@jsluna/images";
import { Sainsburys, Nectar, Argos } from "images/pride";
import { isMultiMissionUrl, isLoginUrl } from "utils/urls";
import isMobile from "utils/isMobile";
import DocumentHead from "./DocumentHead";

const logoMap = {
  nectar: isMobile() ? (
    <NectarWordmarkWhite label="Nectar" width="110px" />
  ) : (
    <Nectar label="Nectar" width="110px" />
  ),
  smartshop: (
    <SainsburysSmartShop label="Sainsbury's SmartShop" width="140px" />
  ),
  argos: <Argos label="Argos" width="82px" />,
  default: (
    <Sainsburys
      label="Sainsburys Group plc"
      width={isMobile() ? "96px" : "140px"}
    />
  ),
};

const colourMap = {
  nectar: "ln-u-bg-color-purple",
  default: "ln-u-bg-color-white",
};

const makeLogo = (BrandLogo) => {
  return logoMap[BrandLogo] || logoMap["default"];
};

const getHeaderColour = (logo) => {
  return colourMap[logo] || colourMap["default"];
};

const shouldShowHeader = (url) =>
  isMultiMissionUrl(url) || isLoginUrl(url) ? false : true;

const Header = ({ missionHomepage }) => {
  const [logo] = useGlobal("logo");
  const [readable_mission_name] = useGlobal("readable_mission_name");

  return (
    <>
      <DocumentHead logo={logo} mission={readable_mission_name} />
      {shouldShowHeader(window.location.pathname) && readable_mission_name && (
        <PageHeader>
          <div
            style={{ padding: "20px", lineHeight: 0 }}
            className={getHeaderColour(logo)}
          >
            <div data-testid="mission-logo">{makeLogo(logo)}</div>
          </div>
        </PageHeader>
      )}
    </>
  );
};

export default withGlobal((global) => ({
  missionHomepage: global.mission_homepage,
}))(Header);
